export default __webpack_public_path__ + "static/media/ANDRES VALDIVIA.245acf9d.jpeg";